import { List, ListContentProps, ListDescriptionProps, ListHeaderProps, ListItemProps, ListProps } from "semantic-ui-react";

type BPListProps = ListProps & {};

export function BPList(props: BPListProps) {
    return <List {...props}>{props.children}</List>;
}

type BPListItemProps = ListItemProps & {};

export function BPListItem(props: BPListItemProps) {
    return <List.Item {...props}>{props.children}</List.Item>;
}

type BPListHeaderProps = ListHeaderProps & {};

export function BPListHeader(props: BPListHeaderProps) {
    return <List.Header {...props}>{props.children}</List.Header>;
}

type BPListContentProps = ListContentProps & {};

export function BPListContent(props: BPListContentProps) {
    return <List.Content {...props}>{props.children}</List.Content>;
}

type BPListDescriptionProps = ListDescriptionProps & {};

export function BPListDescription(props: BPListDescriptionProps) {
    return <List.Description {...props}>{props.children}</List.Description>;
}